// extracted by mini-css-extract-plugin
export default {"title":"OnboardingPageTitle_title__CSO7z"};